import axios from "axios";

export const axiosLoginInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKOFFICE_URL + '/partners/v1/',
    timeout: 45000,
    withCredentials: false
});

export default axiosLoginInstance;
